import { RotateCcw, Loader } from "lucide-react";

import { getText, interpolate } from "shared/lib";

import { useCancelOrCompleteApplication } from "@/hooks";

import { Button } from "shared/components";
import { AddErrorDiagram } from "../AddressErrorDiagram";

export function AddressError() {
  const {
    isPending: cancelOrCompleteApplicationLoading,
    cancelOrCompleteApplication,
  } = useCancelOrCompleteApplication({});

  const handleClickRestart = () => {
    console.log("<AddressError> handleClickRestart()");
    cancelOrCompleteApplication();
  };

  return (
    <div
      className="wizard-step-transition flex h-full w-full flex-col gap-5 text-bodylg md:max-w-[600px]"
      data-testid="step-container-multi-select"
    >
      <div className="flex flex-col gap-5">
        <h1 className="text-headingxl text-textPrimary">
          {getText("🤕 We're sorry, something went wrong")}
        </h1>

        <div className="text-bodylg rounded-xs bg-interfaceBgDarkPaper border-interactiveBorder border-l-4 p-3 pl-4">
          {interpolate(
            "An error occurred and we couldn't retrieve details about the address you entered. {{button}}, or if you continue to see this error, contact your council by phone or email to discuss your proposal.",
            {
              button: (
                <Button
                  className="underline"
                  disabled={cancelOrCompleteApplicationLoading}
                  onClick={handleClickRestart}
                  size="tight"
                  variant="link"
                >
                  {getText("Re-enter the address")}
                </Button>
              ),
            },
          )}
        </div>

        <div className="flex justify-center rounded bg-[#EFF7FF]">
          <AddErrorDiagram className="max-w-full" />
        </div>

        <div className="flex justify-end pt-5">
          <Button
            disabled={cancelOrCompleteApplicationLoading}
            onClick={handleClickRestart}
            variant="outline"
          >
            {cancelOrCompleteApplicationLoading ? (
              <>
                <Loader className="animate-spin" />
              </>
            ) : null}
            {getText("Restart")} <RotateCcw />
          </Button>
        </div>
      </div>
    </div>
  );
}
